module.exports = __webpack_public_path__ + "letterFadeScaleStartIn.gif";